import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AudioService {
    public current: Observable<string>;
    private currentSubject: BehaviorSubject<string>;

    constructor() {
        let val = localStorage.getItem('AUDIO');

        // TODO: cleanup, this can be removed later
        if (!!val && val === 'NULL') {
            localStorage.removeItem('AUDIO');
            val = null;
        }
        this.currentSubject = new BehaviorSubject<string>(val);
        this.current = this.currentSubject.asObservable();
    }

    public get currentValue(): string {
        return this.currentSubject.value;
    }

    setCurrent(obj: string) {
        if (!!obj) {
            localStorage.setItem('AUDIO', obj);
        } else {
            localStorage.removeItem('AUDIO');
        }
        this.currentSubject.next(obj);
    }
}
